/**
 * Created by Pali on 02/10/18.
 */

angular.module("screensApp").controller("TeamAnalysisController", function ($scope, $rootScope, $timeout) {
  var self = this;
  self.teamAnalysisCancelTimeout = null;

  // Show TeamAnalysis Container
  $rootScope.showTeamAnalysis = function (data) {
    $timeout.cancel(self.teamAnalysisCancelTimeout);
    self.teamAnalysisCancelTimeout = $timeout(function () {
      $rootScope.hideTeamAnalysis();
    }, $rootScope.settings.teamAnalysis.hideTimeout);

    try {
      $scope.loadTeamAnalysis(data);
    } catch (err) {
      $rootScope.config.DebugJsConsoleLogEnabled && console.log('# ERROR: showTeamAnalysis() data: ' + data + ' err: ' + err.toString());
      $rootScope.hideTeamAnalysis();
    }
  };

  // Hide TeamAnalysis Container
  $rootScope.hideTeamAnalysis = function () {
    $timeout.cancel(self.teamAnalysisCancelTimeout);
    $rootScope.settings.teamAnalysis.show = false;
    return false;
  };

  $scope.loadTeamAnalysis = function (data) {
    // TODO: ak sa niekedy zapne, treba zmenit 'staru' static url za aws static url
    $rootScope.teamAnalysisImageUrl = $rootScope.url.StaticURL + "sportbox/team_analysis/leagues/" + data.regionID + "/" + data.teamOrder + ".jpg";
    $rootScope.settings.teamAnalysis.show = true;
  };
});
